import React from 'react';

import { CreateClaimValues } from '@/types';
import { ORDER_LOGIN_CONFIGURATION } from '@/types/Client';

import EmailOrderReference from './EmailOrderReference/EmailOrderReference';
import OnlyWithOrderReference from './OnlyWithOrderReference/OnlyWithOrderReference';
import PhoneNumberLoginEnable from './PhoneNumberLoginEnable/PhoneNumberLoginEnable';
import PurchaseDateLoginEnable from './PurchaseDateLoginEnable/PurchaseDateLoginEnable';
import StandardPriceLogin from './StandardPriceLogin/StandardPriceLogin';

interface CustomerInvoiceInformationsProps {
  values: CreateClaimValues;
}

const CustomerInvoiceInformations: React.FC<
  CustomerInvoiceInformationsProps
> = ({ values }) => {
  return (
    <>
      {values.orderLoginConfiguration ===
        ORDER_LOGIN_CONFIGURATION.ONLY_WITH_ORDERREFERENCE && (
        <OnlyWithOrderReference values={values} />
      )}
      {values.orderLoginConfiguration ===
        ORDER_LOGIN_CONFIGURATION.PHONE_NUMBER_LOGIN_ENABLE && (
        <PhoneNumberLoginEnable values={values} />
      )}
      {values.orderLoginConfiguration ===
        ORDER_LOGIN_CONFIGURATION.STANDARD_PRICE_LOGIN && (
        <StandardPriceLogin values={values} />
      )}
      {values.orderLoginConfiguration ===
        ORDER_LOGIN_CONFIGURATION.EMAIL_LOGIN_ENABLE && (
        <EmailOrderReference values={values} />
      )}
      {values.orderLoginConfiguration ===
        ORDER_LOGIN_CONFIGURATION.PURCHASE_DATE_LOGIN_ENABLE && (
        <PurchaseDateLoginEnable values={values} />
      )}
    </>
  );
};

CustomerInvoiceInformations.displayName = 'CustomerInvoiceInformations';

export default CustomerInvoiceInformations;
